export default "__VITE_ASSET__BxZy1k4K__"